import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import {  ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import StatusCard from "../../components/UI_Kit/StatusCard/StatusCard";
import TableComponent from "../../components/DataTable/DataTable";
import api from "../../services/api";
import "./styles.css";
import { handleLogout } from "../../utils/authUtils";

const Home = () => {
  // const StatusCardData = [
  //   { number: 9, title: "Brouillons" },
  //   { number: 16, title: "En attente", badge: 2 },
  //   { number: 8, title: "Validés" },
  //   { number: 27, title: "Envoyés", badge: 5 },
  //   { number: 40, title: "Devis gagnés" },
  //   { number: 35, title: "Devis perdus" },
  // ];
  const navigate = useNavigate();
  // State for quotation data
  const [quotationData, setQuotationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(20); // Or get from API if dynamic

  // Fetch data from API using the api service
  useEffect(() => {
    const fetchQuotations = async (pageToFetch) => {
      try {
        setLoading(true);

        // Get the token from localStorage
        const token = localStorage.getItem("access_token");

        // Set the authorization header with the token
        const response = await api.get("/quotations", {
          params: {
            per_page: perPage,
            page: pageToFetch, // Use the pageToFetch parameter
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // Transform API data to match table format
        const transformedData = response.data.data.map((item) => ({
          id: item.quotation_number,
          quotationId: item.id, // Add the actual quotation ID here
          status: capitalizeFirstLetter(item.status),
          company: item.organization_name,
          creationDate: formatDate(item.created_at),
          devisNumber: item.quotation_number,
          totalTTC: item.total_purchase_price_incl_tax
            ? `$${item.total_purchase_price_incl_tax}`
            : "N/A",
          type: "Devis", // Default type if not available in API
          translated_status: item.translated_status,
          pfd_link: item.pdf
        }));
        setQuotationData(transformedData);
        // Assuming your API response has a 'pagination' object as described
        if (response.data.pagination) {
          setCurrentPage(response.data.pagination.current_page);
          setTotalPages(response.data.pagination.last_page);
          setPerPage(response.data.pagination.per_page);
        }

      } catch (err) {
        console.error("Error fetching quotations:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchQuotations(currentPage); // Fetch initial page
  }, [currentPage, perPage]); // Add currentPage and perPage as dependencies

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  // Helper function to capitalize first letter
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleDataChange = (updatedData) => {
    setQuotationData(updatedData);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleLogoutClick = (event) => {
    event.preventDefault(); // Prevent default Link navigation
    handleLogout(navigate);
  };

  return (
    <>

      <Helmet>
        <title>Lease Protect</title>
        <meta name="description" content="Dashboard" />
      </Helmet>
      {/* Header */}
      <div className="mt-3">
        <div className="header d-flex justify-content-between">
          <h2 className="dashboard-title">Mes devis</h2>
          <Link className="d-block d-lg-none" onClick={handleLogoutClick}>
            <img src="/user_icon.png" alt="user" />
          </Link>
        </div>

        {/* Status card */}
        {/* <div className="row g-3 mt-2">
            {StatusCardData.map((item, index) => (
              <div className="col-6 col-sm-6 col-md-4" key={`CardIndex-${index}`}>
                <Link to="/invoice" className="text-decoration-none">
                  <StatusCard
                    number={item.number}
                    title={item.title}
                    badge={item.badge}
                  />
                </Link>
              </div>
            ))}
          </div> */}

        {/* Data table */}
        <div className="data-table mb-3 mt-4">
          {loading ? (
            <div className="loading-container">
              <img
                src="/favicon.ico"
                alt="Loading"
                className="loading-icon"
              />
              <div className="loading-text">Chargement...</div>
            </div>
          ) : error ? (
            <p>Error loading data: {error}</p>
          ) : (
            <TableComponent
              data={quotationData}
              onDataChange={handleDataChange}
              // Pass pagination props to TableComponent
              currentPage={currentPage}
              totalPages={totalPages}
              perPage={perPage}
              onPageChange={handlePageChange} // Pass the handler function
              loading={loading} // Pass loading state for table to potentially show its own loader
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
